import { Button } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useAddMailingIntegrationMutation } from "../../integrationsApiSlice";

export const DisconnectSMTP = () => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();

	const [disconnectMailingIntegrationMutation, { isLoading }] =
		useAddMailingIntegrationMutation();

	const handleDisconnect = async () => {
		await disconnectMailingIntegrationMutation({
			emailReplyFrom: "",
			emailUsername: "",
			emailPassword: "",
			smtpHost: "",
			smtpPort: "",
			smtpEncryption: "",
			smtpValidateCert: "",
		})
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("disconnected_smtp_connection"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([_key, message]) => {
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Button
			variant="contained"
			loading={isLoading}
			disabled={isLoading}
			onClick={handleDisconnect}
			color="error"
			sx={{
				position: "relative",
				overflow: "hidden",
				display: "flex",
				alignItems: "center",
				gap: "8px",
			}}
		>
			{t("unlink_smtp")}
		</Button>
	);
};
